/**
 * Directly from fnakstad
 * https://github.com/fnakstad/angular-client-side-auth/blob/master/client/js/routingConfig.js
 */
'use strict';

const config = {
    accessLevels: [
        'public',
        'campaign',
        'report',
        'user',
        'place',
        'beacon',
        'application',
        'superuser',
        'section',
        'menu',
        'users',
        'messages',
        'products',
        'reviews',
        'orders',
        'shops',
        'exhibitors',
        'news',
        'games',
        'dishes',
        'notes',
        'levels',
        'meetings',
        'ads',
        'gamifications',
        'provider',
        'chats',
        'maps',
        'posts',
        'cms_www',
        'competitions',
        'groups',
        'files',
        'sso',
        'libraries',
        'galleries',
        'forms',
        'polls',
        'recipes',
        'promotions',
        'newspapers',
        'evaluations',
        'banners',
        'level_rebuses',
        'rebuses',
        'logs',
        'price_lists',
        'coupons',
        'integrations',
        'users_www',
        'crm_users',
        'categories',
        'shopping_lists',
        'facets',
        'short_codes',
        'themes'
    ]
};

// Method to build a distinct bit mask for each role
// It starts off with '1' and shifts the bit to the left for each element in the
// roles array parameter
const buildAccessLevels = (accessLevels) => {
    let bitMask = '01';
    const userAccess = {};

    for (const level in accessLevels) {
        bitMask = level % 32 === 0 ? '01' : bitMask;
        const intCode = parseInt(bitMask, 2);
        userAccess[accessLevels[level]] = {
            bitMask: intCode,
            title: accessLevels[level]
        };
        bitMask = (intCode << 1).toString(2);
    }

    return userAccess;
};

const accessLevels = buildAccessLevels(config.accessLevels);

export {accessLevels};
